import apiUrls from '@/urls';

const INVENTORY_HEAD = '10104';
const CASH_AND_BANK_HEAD = '10101';
const MAX_RESULTS = 50;

// Account ids of `rootId` and every head below it in the chart.
function subtreeIds(accounts, rootId) {
  const children = new Map();
  accounts.forEach((account) => {
    const parent = String(account.p_id);
    if (!children.has(parent)) children.set(parent, []);
    children.get(parent).push(String(account.account_id));
  });

  const ids = new Set([rootId]);
  const queue = [rootId];
  while (queue.length) {
    (children.get(queue.shift()) || []).forEach((id) => {
      if (!ids.has(id)) {
        ids.add(id);
        queue.push(id);
      }
    });
  }
  return ids;
}

/**
 * Heads a voucher line may post to: Child accounts only, never Inventory (10104) or anything under it
 * (stock moves through purchases, sales and adjustments, not vouchers).
 */
export async function fetchVoucherHeads(axios) {
  const response = await axios.get(apiUrls.chart_of_accounts.get);
  const accounts = response.data || [];
  const inventory = subtreeIds(accounts, INVENTORY_HEAD);
  return accounts
    .filter((account) => account.status === 'Child' && !inventory.has(String(account.account_id)))
    .map((account) => ({ ...account, node: (account.node || '').trim() }));
}

/** Cash and bank accounts: the Child heads under Cash & Cash Equivalent (10101), e.g. Cash in Hand, bKash. */
export async function fetchCashBankHeads(axios) {
  const response = await axios.get(apiUrls.chart_of_accounts.get);
  const accounts = response.data || [];
  const cashAndBank = subtreeIds(accounts, CASH_AND_BANK_HEAD);
  return accounts
    .filter((account) => account.status === 'Child' && cashAndBank.has(String(account.account_id)))
    .map((account) => ({ ...account, node: (account.node || '').trim() }));
}

export function searchVoucherHeads(heads, query) {
  const term = (query || '').trim().toLowerCase();
  if (!term) return [];
  return heads
    .filter((head) => head.node.toLowerCase().includes(term) || String(head.account_id).includes(term))
    .slice(0, MAX_RESULTS);
}
